import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import InfoIcon from "@material-ui/icons/Info";
import Lampu from "@material-ui/icons/EmojiObjectsOutlined";
// import BuildIcon from '@material-ui/icons/Build';
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";
import { Collapse } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		background: "#243d32",
		// background: "rgba(75,178,115,0.9)",
		margin: "5px",
	},
	media: {
		height: 40,
	},
	icons: {
		alignItems: "center",
		fontSize: "6rem",
		color: "#fff",
		marginRight: 50,
		marginLeft: 50,
	},
	text: {
		color: "#fff",
		textAlign: "center",
		marginTop: 50,
	},
	wrapper: {
		display: "flex",
		justifyContent: "space-between",
		marginRight: 0,
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "none",
		boxShadow: theme.shadows[10],
		padding: theme.spacing(4, 10, 10),
		width: "100%",
		maxWidth: "90vw",
		maxHeight: "80%",
		position: "fixed",
		top: "50%",
		left: "10",
		transform: "translate(0, -50%)",
		overflowY: "auto",
	},
	closeButton: {
		border: "none",
		color: "red",
	},
	garis: {
		borderWidth: "10px",
		color: "green",
	},
	noblue: {
		textDecoration: "none",
	},
}));

export default function Imagecard({ checked }) {
	const classes = useStyles();
	return (
		<Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}>
			{/* <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}> */}
			{/* <div className={classes.wrapper}> */}
			<Grid container justify="center" alignItems="center" spacing={3}>
				{/* kikd */}
				<Grid>
					<Card className={classes.root}>
						<CardActionArea>
							<Link className={classes.noblue} to="/kidankd">
								<CardMedia className={classes.media}>
									<Lampu className={classes.icons} />
								</CardMedia>
								<CardContent>
									<Button size="small" color="primary">
										<h4 className={classes.text}>KI/KD</h4>
									</Button>
								</CardContent>
							</Link>
						</CardActionArea>
					</Card>
				</Grid>
				{/* materi */}
				<Grid item>
					{/* MAAATEEERIIII */}
					<Card className={classes.root}>
						<CardActionArea>
							<Link className={classes.noblue} to="/materi">
								<CardMedia className={classes.media}>
									<MenuBookIcon className={classes.icons} />
								</CardMedia>
								<CardContent>
									<Button size="small" color="primary">
										<h4 className={classes.text}>Materi</h4>
									</Button>
								</CardContent>
							</Link>
						</CardActionArea>
					</Card>
				</Grid>
				{/* informasi */}
				<Grid item>
					{/* INFORMASIIIIII */}
					<Card className={classes.root}>
						<CardActionArea>
							<Link className={classes.noblue} to="/informasimedia">
								<CardMedia className={classes.media}>
									<InfoIcon className={classes.icons} />
								</CardMedia>
								<CardContent>
									<Button size="small" color="primary">
										<h4 className={classes.text}>Informasi</h4>
									</Button>
								</CardContent>
							</Link>
						</CardActionArea>
					</Card>
				</Grid>
			
			</Grid>

		</Collapse>
		// </div>
	);
}
